/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Deposit_Collection_EmailInputs */

const en_reference_field_deposit_collection_email = /** @type {(inputs: Reference_Field_Deposit_Collection_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deposit collection address`)
};

/**
* | output |
* | --- |
* | "Deposit collection address" |
*
* @param {Reference_Field_Deposit_Collection_EmailInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_deposit_collection_email = /** @type {((inputs?: Reference_Field_Deposit_Collection_EmailInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Deposit_Collection_EmailInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_deposit_collection_email(inputs)
});